// TODO: Remove this file once this component is consumable from app/developer-v3/teams/team-technical-support-operations/get-help
import React, { Fragment } from 'react';

import { HeadingLevel, Text } from '@zapier/design-system';

type SizeType = 'small' | 'medium' | 'large';

type SectionProps = {
  /** Title to display. */
  title: string;
  /** Optional children to render one heading level lower. */
  children?: React.ReactNode;
  /** Size to display. */
  size?: SizeType;
};

/**
 *  * Renders a title, with optional children under the next heading level.
 *   */
const Section = ({ children, title, size = 'large' }: SectionProps) => (
  <Fragment>
    <Text type={size === 'small' ? 'SectionHeader' : 'PageHeader'}>
      {title}
    </Text>
    {children && (
      <HeadingLevel>
        <Text>{children}</Text>
      </HeadingLevel>
    )}
  </Fragment>
);

export default Section;
